export default {
  mounted() {
    if (this.$route.params.id) {
      this.isEdit = true;
      this.loadProduct();
    }
  },
};
